import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

/**
 * Splits text into words (default) or characters and reveals each from below a mask.
 * `once` → animate on mount; otherwise reveal when in view.
 */
export default function SplitText({
  text,
  as: Tag = "span",
  by = "word",
  delay = 0,
  stagger = 0.045,
  duration = 0.9,
  inView = false,
  className = "",
  ...rest
}) {
  const parts = by === "char" ? Array.from(text) : text.split(" ");
  const trigger = inView ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } } : { animate: "show" };

  return (
    <Tag className={className} {...rest}>
      <motion.span
        className="inline"
        initial="hidden"
        {...trigger}
        variants={{ hidden: {}, show: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
      >
        {parts.map((p, i) => (
          <span key={i} className="inline-block overflow-hidden align-bottom pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className="inline-block"
              variants={{
                hidden: { y: "110%", rotate: 3 },
                show: { y: "0%", rotate: 0, transition: { duration, ease: EASE } },
              }}
            >
              {p === " " ? "\u00A0" : p}
            </motion.span>
            {by === "word" && i < parts.length - 1 ? "\u00A0" : null}
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}
